// クリックしたらopen-menuクラス付与
const storeMenuToggle = (menus) => {
    for (let menu of menus) {
        menu.addEventListener('click', () => {
            menu.classList.toggle('open-menu');
        });
    }

    // 要素以外クリックでopen-menuクラス削除
    document.addEventListener('click', (e) => {
        if(!e.target.closest('.store_menu_toggle') && !e.target.closest('.store_sub_menu')) {
            for (let menu of menus) {
                menu.classList.remove('open-menu');
            }
        }
    });
}

// ストアメニュー
const storeMenuToggleBtn = document.querySelectorAll('.store_menu_toggle');
storeMenuToggle(storeMenuToggleBtn);

// 特集記事
$(function() {
    $("#pickupBtn").click(function () {
        $("#pickupArticles").slideToggle(500,alertFunc);
    });

    function alertFunc(){
        if ($(this).css('display') == 'block') {
            $("#pickupBtn").text("特集を閉じる");
            $("#pickupBtn").addClass("close");
        }else{
            $("#pickupBtn").text("特集を見る");
            $("#pickupBtn").removeClass("close");
        }
    };
});

// ピックアップ記事スライド
window.addEventListener('load', () => {
    const pickupArticle = document.querySelector('.pickup_article');
    const slideButtons = document.querySelectorAll('.pickup_articles .slide_btn');
    for ( let btn of slideButtons) {
        btn.addEventListener( 'click', () => {
            let firstArticle = document.querySelector('.pickup_article_link:first-child');
            let lastArticle = document.querySelector('.pickup_article_link:last-child');
            if ( btn.classList.contains('next') ) {
                if (firstArticle != null ) {
                    pickupArticle.append(firstArticle);
                }
            } else {
                if (lastArticle != null ) {
                    pickupArticle.prepend(lastArticle);
                }
            }
        })
    }
});
